<button mat-mini-fab class="closex" color="warn">
  <mat-icon>close</mat-icon>
</button>
<div
  class="card"
  (mousedown)="$event.stopPropagation()"
  (touchstart)="$event.stopPropagation()"
  (click)="$event.stopPropagation()"
>
  <div class="card-header">
    <span class="card-title"> Component conditions help</span>
    <p>
      Conditions allow users to control the behavior (visibility or ability) of
      tasks based on various parameters. Below is a guide to setting up
      conditions effectively. Click on an Operator or Condition to select it.
    </p>
    <div class="mt-1 d-flex justify-content-center">
      <span
        class="ctc mx-1"
        (click)="copyToClipboard(operator.op)"
        *ngFor="let operator of operators"
        >{{ operator.op }}</span
      >
    </div>
  </div>
  <div class="card-body">
    <h6>Condition Syntax</h6>
    <p>
      Conditions are defined using logical operators and
      <span class="tag">Tag</span> values. The supported operators include:
    </p>
    <table>
      <tr>
        <th>Operator</th>
        <th>Definition</th>
        <th>Example</th>
      </tr>
      <tr *ngFor="let operator of operators">
        <td>
          <span class="ctc" (click)="copyToClipboard(operator.op)">{{
            operator.op
          }}</span>
        </td>
        <td>{{ operator.definition }}</td>
        <td>
          <span [innerHTML]="operator.example"></span>
        </td>
      </tr>
    </table>

    <h6 class="mt-3">Nested Conditions</h6>
    <p>
      Parentheses can be used for grouping conditions:<br />
      (<b>Tag1</b> == 2 && <b>Tag2</b>) || <b>!Tag3</b>
    </p>

    <h6 class="mt-3">Handling Different Data Types</h6>
    <p>Conditions supports various data types:</p>
    <table>
      <tr>
        <th>Type</th>
        <th>Example</th>
        <th>Explanation</th>
      </tr>
      <tr>
        <td><b>Boolean</b></td>
        <td>
          <b>Tag1</b><br />
          <b>!Tag3</b>
        </td>
        <td>Tag1 is true<br />Tag 3 is falsy</td>
      </tr>
      <tr>
        <td><b>Numeric</b></td>
        <td><b>Tag2</b> == 10</td>
        <td>Checks if Tag2 equals 10</td>
      </tr>
      <tr>
        <td><b>Signatures</b></td>
        <td>
          <b>Tag1<br />!Tag3</b>
        </td>
        <td>
          Checks if Tag1 has been signed<br />Checks if Tag3 hasn't been signed
        </td>
      </tr>
    </table>

    <h6 class="mt-3">Special Conditions</h6>
    <p>Some predefined general conditions are available:</p>
    <ul>
      <li *ngFor="let gc of generalConditions">
        <span class="mr-1 ctc" (click)="copyToClipboard(gc.value)">{{ gc.value }}</span><span [innerHTML]="gc.description"></span>
      </li>
    </ul>
    <div *ngIf="conditions">
      <h6 class="mt-3">Form Conditions</h6>
      <p>
        <b>{{ formTypeName }}</b> Form predefined conditions available (You can
        copy and paste):
      </p>
      <ul>
        <li
          *ngFor="let condition of conditions"
          class="ctc"
          (click)="copyToClipboard(condition)"
        >
          {{ condition }}
        </li>
      </ul>
    </div>
    <div *ngIf="checklistConditions?.length">
      <h6 class="mt-3">Checklist Conditions</h6>
      <p>Conditions used in this checklist's tasks (click to copy and paste):</p>
      <ul>
        <li
          *ngFor="let c of checklistConditions"
          class="ctc"
          (click)="copyToClipboard(c)"
        >
          {{ c }}
        </li>
      </ul>
    </div>
    <div *ngIf="multipleStatusConditionOptions.length">
      <h6 class="mt-3">Multiple Status Change Values</h6>
      <p>
        The selected radio option is saved as a numeric value. Use these values
        when a condition references this component tag:
      </p>
      <table>
        <tr>
          <th>Tag</th>
          <th>Value</th>
          <th>Option</th>
          <th>Status</th>
          <th>Example</th>
        </tr>
        <tr *ngFor="let option of multipleStatusConditionOptions">
          <td>
            <span class="ctc" (click)="copyToClipboard(option.taskCode)">{{
              option.taskCode
            }}</span>
          </td>
          <td>
            <span class="ctc" (click)="copyToClipboard(option.example)">{{
              option.value
            }}</span>
          </td>
          <td>
            <span class="ctc" (click)="copyToClipboard(option.example)">{{
              option.label
            }}</span>
          </td>
          <td>
            <span class="ctc" (click)="copyToClipboard(option.example)">{{
              option.statusDescription
            }}</span>
          </td>
          <td>
            <span class="ctc" (click)="copyToClipboard(option.example)">{{
              option.example
            }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
